// Config file
import "firebase/analytics";
import * as firebase_app from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const config = {
  apiKey: "AIzaSyBl4iDeMx9cfbDKcpplO-Ty1SgRncsmcnY",
  authDomain: "covid-calculator.firebaseapp.com",
  databaseURL: "https://covid-calculator.firebaseio.com",
  projectId: "covid-calculator",
  storageBucket: "covid-calculator.appspot.com",
  messagingSenderId: "167304346834",
  appId: "1:167304346834:web:06c10cfc8b2343136b410b",
  measurementId: "G-5EKZCB49D2",
};

const defaultApp = firebase_app.initializeApp(config);

export default defaultApp;
